import { OurPartnersCountryService } from '../../pages/our-partners/our-partners.country.service';
import { InterfaceCountry, InterfaceCountryItem } from '../../interface/partner/interface.country';
import { activationClasses, currentUrl, numberSystemDecimal, searchParams } from '../../common/consts';
import { partnersTemplateHtml } from '../../common/templates/elements-with-filter-templates/partners-template.html';
import queryString from 'query-string';
import { SwiperSettings } from '../../common/swiper.settings';
import { ElementsWithFilterPartner } from '../../pages/our-partners/elements.with.filter.parner';

export class CountryComponent {

  private selectedCountryId: number | string | null;
  constructor(
    private container: HTMLElement | null,
    private loader: HTMLElement | null,
    private switchers: HTMLElement[],
    private categoryId: number | null = null,
    private showMoreHtmlElement: HTMLElement | null,
    private isDynamic: boolean = false,
  ) {
    this.selectedCountryId = 0;
  }
  public initialize(): void {
    const queryParams: Record<string, number | string | null> = {};
    const ourPartnersCountryService = new OurPartnersCountryService(this.loader);

    let html = '';

    ourPartnersCountryService.getCountries(this.categoryId ?? null).then((country: InterfaceCountry | null) => {
      const elementsWithFilter: HTMLElement | null = document.querySelector(`[data-elements-with-filter]`);

      if (country) {
        const defaultCountryId = country.Countries.length > 0 ?  country.Countries[0]?.Id: null;
        let countryId = searchParams.get('countryId') ?? defaultCountryId;

        if (countryId) {
          searchParams.set('countryId', String(countryId));
          currentUrl.search = searchParams.toString();
          const path = currentUrl.toString();
          history.pushState(null, '', path);
        }

        if (this.categoryId) {
          queryParams.categoryId = this.categoryId;
        }
        if (countryId) {
          queryParams.countryId = countryId;
        }
        if (country.Countries.length === 0) {
          delete queryParams.countryId;
        }
        this.initElementsWithFilter(elementsWithFilter, queryParams);
        if (country.Countries.length > 0 && !countryId) {
          const countryIdInt = country.Countries[0]?.Id;
          if (countryIdInt) {
            countryId = countryIdInt.toString() ?? null
          }
        }
        country.Countries.forEach((countryItem: InterfaceCountryItem) => {

          html += `
            <div
              class="our-partners__filter-button swiper-slide swiper-slide--kind-height"
              data-partner-country="${countryItem.Id}"
              data-partner-country-name="${countryItem.Name}"
            >
              <h6>${countryItem.Name}</h6>
            </div>
          `
        });

        if (this.container) {
          this.container.innerHTML = html;
        }
        new SwiperSettings().initialize();

        queryParams.countryId = countryId;
        // Вынести в отдельный класс переключение по кнопкам
        const partnerCountries: HTMLElement[]
          = Array.prototype.slice.call(document.querySelectorAll('[data-partner-country]'));

        partnerCountries.forEach((partnerCountry: HTMLElement) => {
          const itemCountryId = partnerCountry.dataset.partnerCountry;
          if (countryId && itemCountryId) {
            partnerCountry.classList.remove(activationClasses.active);
            if (parseInt(itemCountryId, numberSystemDecimal) === parseInt(String(countryId), numberSystemDecimal) ) {
              partnerCountry.classList.add(activationClasses.active);
            }
          }
          partnerCountry.addEventListener('click', (e): void => {
            if (!partnerCountry.classList.contains(activationClasses.active)) {
              e.stopPropagation();
              const countryId = partnerCountry.dataset.partnerCountry;
              if (countryId) {
                queryParams.countryId = countryId;
              }
              partnerCountries.forEach((partnerCountryItem: HTMLElement) => {
                partnerCountryItem.classList.remove(activationClasses.active);
              });
              if (country.Countries.length === 0) {
                delete queryParams.countryId;
              }
              partnerCountry.classList.add(activationClasses.active);
              this.initElementsWithFilter(elementsWithFilter, queryParams);
              if (countryId) {
                searchParams.set('countryId', countryId);
                currentUrl.search = searchParams.toString();
                const path = currentUrl.toString();
                history.pushState(null, '', path);
              }
            }
          });
        });
        if (country.Countries.length === 1) {
          partnerCountries[0].classList.add(activationClasses.active);
        }
      }
    });

  }
  private initElementsWithFilter(
    elementsWithFilter: HTMLElement | null,
    queryParams: Record<string, number | string | null>
  ) {

    new ElementsWithFilterPartner(
      elementsWithFilter,
      this.loader,
      this.switchers,
      6,
      partnersTemplateHtml,
      `partners?${queryString.stringify(queryParams)}`,
      'partners',
      this.showMoreHtmlElement,
      0,

    )
  }
}
